import React, { useState, useEffect } from 'react'
import { useJsApiLoader } from '@react-google-maps/api';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { FormGroup, Input, Label } from 'reactstrap';
import { ValidableFeedback } from './Validable';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import { isNullOrUndefined } from 'util';

export class Location {
  constructor(address, city, region, country, postalCode, lat, lng) {
    this.address = address || '';
    this.city = city || '';
    this.region = region || '';
    this.country = country || '';
    this.postalCode = postalCode || '';
    this.lat = lat || 0;
    this.lng = lng || 0;
  }
}


const libraries = process.env.NX_REACT_APP_GOOGLE_LIBRARIES?.split(',');

export function LocationSearchInput({id, className, label, placeholder, location, onLocationChange, required, readOnly}) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.NX_REACT_APP_GOOGLE_API_KEY,    
    libraries: libraries
  });

  const [address, setAddress] = useState('');
  const [mapURL, setMapURL] = useState(undefined);
  const [decoded, setDecoded] = useState(false);
  const [locationOld, setLocationOld] = useState(location);

  useEffect(() => {
    if (!isNullOrUndefined(location)) {
      let mapURL = undefined;
      if (
        !isNullOrUndefined(location.lat) &&
        !isNullOrUndefined(location.lng)
      ) {
        setMapURL(`https://www.google.com/maps/?q=${location.lat},${location.lng}`);
      }
      setAddress(location.address +' '+ location.postalCode);
      setDecoded(true);
    }
  }, [location, locationOld]);
  
  const decodeLocation = (address) => {
    //var result;
    geocodeByAddress(address).then((results) => {
      var result = results[0];
      // need to use Promise chaining here so we can access 'result' in the context below
      return getLatLng(result).then((latLng) => {
        var country =
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'country')
          ) || {};
        var province =
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'administrative_area_level_1')
          ) || {};
        var city =
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'sublocality')
          ) ||
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'locality')
          ) ||
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'administrative_area_level_3')
          ) ||
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'neighborhood')
          ) ||
          {};
        var postalCode =
          _.find(result.address_components, (x) =>
            _.includes(x.types, 'postal_code')
          ) || {};

          setAddress(address);
          setDecoded(true);
        
        onLocationChange(
          new Location(
            address,
            city.short_name,
            province.short_name,
            country.short_name,
            postalCode.short_name,
            latLng.lat,
            latLng.lng
          )
        );
      });
    });
  };

  const handleSelect = (address) => {
    if (!decoded) {
      decodeLocation(address);
    }
  };

  const handleBlur = (address) => {
    if (!decoded) {
      decodeLocation(address);
    }
  };

  const handleChange = (address) => {
    if (isNullOrUndefined(address) || address === '') {
      onLocationChange(null);
      setAddress('');
      setDecoded(false);
      setMapURL(undefined);
    } else {
      setAddress(address);
      setDecoded(false);
      setMapURL(undefined);
    }
  };

  const handleError = (error) => {
    if (error !== 'ZERO_RESULTS') {
      return NotificationManager.error(
        `An error occurred when fetching information from Google, please try again. (${error})`
      );
    }
  };
  
  const invalid = required && !location ? true : false;    
  return (
    <div>
      {loadError && <div>Error loading Google Maps API</div>}
      {!isLoaded && <div>Loading...</div>}
      {isLoaded && (
        <PlacesAutocomplete
        value={address}
        onChange={handleChange}
        onSelect={handleSelect}
        onError={handleError}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <FormGroup className={className}>
            {label && (
              <Label for={id} className="form-label">
                {label}
              </Label>
            )}
            <div className= { invalid ? 'input-group location-search-input-group invalid' : 'input-group location-search-input-group'}>
              <Input
                {...getInputProps({
                  placeholder: placeholder,
                  className: "location-search-input",
                })}
                readOnly={readOnly}
                id={id}
                onBlur={handleBlur}
                onFocus={(e) => {
                  if (readOnly) e.target.blur();
                }}          
                autoComplete="nope"
              />
              <ValidableFeedback invalid={invalid} />
              {loading && (
                <div className="input-group-append">
                  <span className="input-group-text text-light">
                    <span>
                      <i className="fa fa-circle-o-notch fa-spin fa-fw" />
                      <span className="sr-only">Loading...</span>
                    </span>
                  </span>
                </div>
              )}
              {mapURL && (
                <div className="input-group-append">
                  <span className="input-group-text text-light">
                    <a
                      className="btn btn-link"
                      style={{ padding: '0' }}
                      href={mapURL}
                      target="_blank"
                    >
                      <span className="icon icon-location" />
                    </a>
                  </span>
                </div>
              )}
            </div>
            <div className="autocomplete-dropdown-container">
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';

                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                    key={index}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </FormGroup>
        )}
      </PlacesAutocomplete>)}
    </div>
  );
};